import { colors } from '@bitcoin-portal/bitcoincom-pkg-theme';
import styled from 'styled-components';

export const QRWrapper = styled.div`
  border: 8px solid lightgray;
  border-radius: 8px;
  padding: 16px;
  & > div {
    padding: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const ModalWrapper = styled.div`
  & > div > div {
    width: auto;
    max-width: 720px;
    border-radius: 16px;
  }
`;

export const Disclaimer = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${colors.solid.cinnabar};
  margin-top: 32px;
`;
